// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d85cfadc","239":"2f822dd7","455":"023cb25f","488":"eb2e1585","661":"d8e64b55","707":"97b5e537","945":"6e4284d3","979":"c46b748b"}[chunkId] + ".chunk.js";
};